export const syteTrackEvent = (data: any) => {
  const maxRetries = 20;
  let retryCount = 0;
  let eventPushed = false;
  let intervalId: any;

  const tryPushEvent = () => {
    if (window.syteDataLayer) {
      window.syteDataLayer.push(data);
      clearInterval(intervalId);
      eventPushed = true;
    } else {
      retryCount++;
      if (retryCount >= maxRetries) {
        clearInterval(intervalId);
        if (!eventPushed) {
          console.error("Maximum retry count reached. Syte event not tracked.");
        }
      }
    }
  };

  tryPushEvent();

  if (!eventPushed) {
    intervalId = setInterval(tryPushEvent, 1000);
  }
};
